
<div class="whatsapp-logo-container">
    <a href="https://wa.me/5519999470064" target="_blank">
        <img src="../assets/images/whatsapp-white-logo.png" height="32">
    </a>
</div>